import * as Types from './Types'
import * as API from './api'

export function tryGetCommunityInformation(token) {
  return dispatch => {
    dispatch({ 
      type: Types.GET_COMMUNITY_INFORMATIONS 
    })

    API.getCommunityInformation(token)
      .then(response => {
        dispatch({
          type: Types.GET_COMMUNITY_INFORMATIONS_SUCCESS,
          payload: response.data.data
        })
      })
      .catch(() => {
        dispatch({
          type: Types.GET_COMMUNITY_INFORMATIONS_FAILED
        })
      })
  }
}




// WEBPACK FOOTER //
// ./src/actions/CommunityInformation.js